// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/list-todo.js';

import { paths } from '../generated/list-todo';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('list-todo', Original, paths);
